  if (!customElements.get('search-filter')) {
	class SearchFilter extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.init();
		}

		async init() {

			this.elements = {
				filterDetails: this.querySelectorAll('details'),
				filterSummary: this.querySelectorAll('summary'),
				loadingSpinner: this.querySelector('.loading__spinner'),
			};
			
			await this.initialFilterRendering();

			this.elements.filterItems = this.querySelectorAll('.filter-select__item:not(.holder):not(.filter-select__clear)'),
			this.elements.filterSubmitButton = this.querySelector('.filter-value');		

			if (!this.elements.filterSubmitButton.hasAttribute('data-previous-href')) {
				this.elements.filterSubmitButton.setAttribute('data-previous-href', this.elements.filterSubmitButton.getAttribute('href'));
			}

			this.previousHref = this.elements.filterSubmitButton.getAttribute('data-previous-href');

			this.elements.filterDetails.forEach(item => {
				item.addEventListener('click', this.closeDetails.bind(this, item));
				const summary = item.querySelector('summary');
				if (summary) {
					summary.setAttribute('tabindex', '0');
					summary.addEventListener('keydown', this.handleKeyDown.bind(this, item));
					item.addEventListener('focusout', this.handleFocusOut.bind(this, item));
					const summaryLabel = summary.querySelector('span');
					if (summaryLabel && !summaryLabel.hasAttribute('data-original-label')) {
						summaryLabel.setAttribute('data-original-label', summaryLabel.textContent.trim());
					}
				}
				this.appendClearItem(item);
			});

			document.addEventListener('click', this.closeAllDetails.bind(this));

			this.elements.filterItems.forEach(item => {
				item.addEventListener('click', this.onClick.bind(this, item));
				item.setAttribute('tabindex', '0');
				item.addEventListener('keydown', this.handleItemKeyDown.bind(this, item));
			});

			this.applyHierarchy();

		}

		handleKeyDown(details, event) {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				details.open = !details.open;
			}
		}

		handleItemKeyDown(item, event) {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				this.onClick(item);
			}
		}

		closeDetails(clickedItem) {
			this.elements.filterDetails.forEach(item => {
				if (item !== clickedItem) {
					item.removeAttribute('open');
				}
			});
		}

		closeAllDetails(event) {
			if (!Array.from(this.elements.filterDetails).some(item => item.contains(event.target))) {
				this.elements.filterDetails.forEach(item => {
					item.removeAttribute('open');
				});
			}
		}

		handleFocusOut(details, event) {
			setTimeout(() => {
				if (!details.contains(document.activeElement)) {
					details.removeAttribute('open');
				}
			}, 0);
		}

		onClick(clickedItem) {
			const parentDetails = clickedItem.closest('details');
			const summaryElement = parentDetails.querySelector('summary span');

			if (summaryElement) {
				summaryElement.textContent = clickedItem.textContent;
			}

			clickedItem.classList.toggle('active');
			const otherItems = parentDetails.querySelectorAll('.filter-select__item:not(.holder):not(.filter-select__clear)');
			otherItems.forEach(item => {
				if (item !== clickedItem) {
					item.classList.remove('active');
				}
			});

			if (!clickedItem.classList.contains('active') && summaryElement) {
				summaryElement.textContent = summaryElement.getAttribute('data-original-label') || summaryElement.textContent;
			}

			this.toggleClearItem(parentDetails);

			parentDetails.removeAttribute('open');
			this.applyHierarchy();

			this.updateFilters();
		}

		appendClearItem(details) {
			const filterSelect = details.querySelector('.filter-select');
			if (!filterSelect || filterSelect.querySelector('.filter-select__clear')) return;

			const li = document.createElement('li');
			li.className = 'filter-select__item filter-select__clear hidden';
			li.setAttribute('tabindex', '0');
			li.setAttribute('role', 'button');
			li.innerText = this.dataset.clearLabel || 'Clear';
			li.addEventListener('click', this.onClearClick.bind(this, details));
			li.addEventListener('keydown', (event) => {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					this.onClearClick(details);
				}
			});

			filterSelect.prepend(li);
		}

		toggleClearItem(details) {
			const clearItem = details.querySelector('.filter-select__clear');
			if (!clearItem) return;
			const hasActive = details.querySelector('.filter-select__item.active:not(.holder):not(.filter-select__clear)');
			clearItem.classList.toggle('hidden', !hasActive);
		}

		onClearClick(details) {
			details.querySelectorAll('.filter-select__item.active').forEach(item => item.classList.remove('active'));

			const summaryElement = details.querySelector('summary span');
			if (summaryElement) {
				summaryElement.textContent = summaryElement.getAttribute('data-original-label') || summaryElement.textContent;
			}

			this.toggleClearItem(details);
			details.removeAttribute('open');
			this.applyHierarchy();

			this.updateFilters();
		}

		applyHierarchy() {
			if (this.dataset.filterMetaobject !== 'true') return;

			const details = Array.from(this.elements.filterDetails);

			details.forEach((detail, index) => {
				if (index === 0) return;
				if (!detail.querySelector('[data-filter-parent-values]')) return;

				const parentDetails = details[index - 1];
				const parentItem = parentDetails.querySelector('.filter-select__item.active:not(.filter-select__clear)');
				const parentValue = parentItem ? parentItem.textContent.trim() : '';

				detail.querySelectorAll('.filter-select__item:not(.holder):not(.filter-select__clear)').forEach(item => {
					const parentValues = item.dataset.filterParentValues || '';
					const visible = !parentValue || parentValues.split('|||').includes(parentValue);

					item.hidden = !visible;
					if (!visible && item.classList.contains('active')) {
						item.classList.remove('active');
						const summaryElement = detail.querySelector('summary span');
						if (summaryElement) {
							summaryElement.textContent = summaryElement.getAttribute('data-original-label') || summaryElement.textContent;
						}
						this.toggleClearItem(detail);
					}
				});
			});
		}

		updateFilters() {
			const activeItems = this.querySelectorAll('.filter-select__item.active:not(.holder)');
			const dataFilterValues = Array.from(activeItems).map(item => item.getAttribute('data-filter')).join('&');
			const currentValue = this.previousHref || '';

			fetch(`${currentValue}?${dataFilterValues}`)
				.then(response => response.text())
				.then(responseText => {
					const html = responseText;
					const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
					const disabledElements = parsedHTML.querySelectorAll('facet-filters-form .list-menu__item input[disabled]');

					this.elements.filterItems.forEach(filterItem => {
						const filterItemValue = filterItem.getAttribute('data-filter');
						filterItem.classList.remove('disabled');
						filterItem.removeAttribute('disabled');

						disabledElements.forEach(disabledElement => {
							const disabledValues = disabledElement.getAttribute('data-filter');

							if (filterItemValue === disabledValues) {
								filterItem.classList.add('disabled');
								filterItem.setAttribute('disabled', '');
								filterItem.setAttribute('tabindex', '-1');
							}
						});
					});
				});

			this.elements.filterSubmitButton.setAttribute('href', `${currentValue}?${dataFilterValues}`);
			this.elements.filterSubmitButton.removeAttribute('aria-disabled');
		}

		async initialFilterRendering() {
			this.elements.loadingSpinner.classList.remove('hidden');
			this.setAttribute('data-loading', 'true');		
			if(this.dataset.collection != 'all') {
				await	this.loadFilters(this.dataset.filterUrl);
			}
			this.removeAttribute('data-loading');
			this.elements.loadingSpinner.classList.add('hidden');
		}

		async loadFilters(url) {
			if (!this.elements.filterDetails) return;

			const res = await fetch(url);
			const html = await res.text();
			const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

			const filtersForm = parsedHTML.querySelector('facet-filters-form')
			let summarySelector = '.facets__summary-label'
			if (!filtersForm) return;

			let filters = filtersForm.querySelectorAll('.facets__summary')

			if (filters.length == 0) {
				filters = filtersForm.querySelectorAll('.mobile-facets__summary')
				summarySelector = 'div > span'
			}

			if (filters.length == 0) return;

			this.elements.filterDetails.forEach( detail => {
				const summary = detail.querySelector('summary > span')
				const filterSelect = detail.querySelector('.filter-select')
				if (!summary || !filterSelect) return;
				const summaryText = summary.innerText.trim();

				filters.forEach(filter => {
					const filterLabel = filter.querySelector(`${summarySelector}`) 
					if (!filterLabel) return;

					const isEqual = filterLabel.innerText.includes(summaryText);
					if (!isEqual) return;
					
					const filterValues = filter.parentElement.querySelectorAll('[data-filter-value-name')
					if (!filterValues) return;

					const filterValuesMap = new Map();

					filterValues.forEach( value => {
						const { filterValueName } = value.dataset;
						const filterId = value.dataset.filter;
						if (!filterValuesMap.has(filterValueName)) {
							filterValuesMap.set(filterValueName, { filterValueName, filterId });
						}
					})

					filterValuesMap.forEach( ({ filterValueName, filterId }) => {
						filterSelect.append(this.createFilterHtml(filterId, filterValueName))
					})
				})
			})
		}

		createFilterHtml(filterId, label) {
			const li = document.createElement('li');
			li.className = 'filter-select__item';
			li.setAttribute('tabindex', '0');
			li.setAttribute('role', 'button');
			li.setAttribute('data-filter', filterId);
			li.innerText = label;

			return li;
		}
	}

	customElements.define('search-filter', SearchFilter);
}